import type { ImageLoaderProps } from '../../types/types'
import { getImageSrc } from '../../utils/getImageSrc/getImageSrc'

export function imageLoader({ src, width }: ImageLoaderProps): string {
	const url = getImageSrc({ src })

	const searchParams = new URLSearchParams({
		wid: width.toString(),
	})
	url.search = searchParams.toString()

	return url.toString()
}
